import 'babel-polyfill';
import { ConnectedRouter, connectRouter, routerMiddleware, RouterState } from "connected-react-router";
import createBrowserHistory                                              from 'history/createBrowserHistory'
import * as LogRocket                                                    from "logrocket";
import * as React                                                        from 'react';
import * as ReactDOM                                                     from 'react-dom';
import { Provider }                                                      from 'react-redux'
import { applyMiddleware, combineReducers, createStore }                 from "redux";
import "semantic-ui-css/semantic.min.css";
import Account                                                           from "./domain/account/Account";
import Corporation                                                       from "./domain/corporation/Corporation";
import Customer                                                          from "./domain/customer/Customer";
import Customers                                                         from "./domain/customer/Customers";
import Facilities                                                        from "./domain/facility/Facilities";
import Count                                                             from "./domain/fundamentals/count/Count";
import FetchStatus                                                       from "./domain/fundamentals/fetch/FetchStatus";
import Errors
                                                                         from "./domain/fundamentals/message/error/Errors";
import Notify
                                                                         from "./domain/fundamentals/message/notify/Notify";
import Pagination
                                                                         from "./domain/fundamentals/pagination/Pagination";
import MailGroup                                                         from "./domain/mail/group/MailGroup";
import MailGroups                                                        from "./domain/mail/group/MailGroups";
import MailSend                                                          from "./domain/mail/send/MailSend";
import MailSetting                                                       from "./domain/mail/setting/MailSetting";
import MailTemplate                                                      from "./domain/mail/template/MailTemplate";
import MailTemplates                                                     from "./domain/mail/template/MailTemplates";
import Notices                                                           from "./domain/notice/Notices";
import Office                                                            from "./domain/office/Office";
import Plan                                                              from "./domain/plan/Plan";
import CustomerRecord                                                    from "./domain/record/customer/CustomerRecord";
import CustomerRecords
                                                                         from "./domain/record/customer/CustomerRecords";
import RecordTemplate                                                    from "./domain/record/template/RecordTemplate";
import RecordTemplates
                                                                         from "./domain/record/template/RecordTemplates";
import ReservationHistories
                                                                         from "./domain/reservation/history/ReservationHistories";
import Reservation                                                       from "./domain/reservation/Reservation";
import Reservations                                                      from "./domain/reservation/Reservations";
import ReservationSetting                                                from "./domain/reservation/ReservationSetting";
import Staff                                                             from "./domain/staff/Staff";
import Staffs                                                            from "./domain/staff/Staffs";
import './index.scss';
import accountReducer
                                                                         from "./infrastructure/redux/account/AccountReducer";
import { fetchStatusReducer }                                            from "./infrastructure/redux/common/fetch/FetchStatusReducer";
import corporationReducer
                                                                         from "./infrastructure/redux/corporation/CorporationReducer";
import customerReducer
                                                                         from "./infrastructure/redux/customer/CustomerReducer";
import customersReducer
                                                                         from "./infrastructure/redux/customer/CustomersReducer";
import errorReducer
                                                                         from "./infrastructure/redux/error/ErrorReducer";
import facilityReducer
                                                                         from "./infrastructure/redux/facility/FacilityReducer";
import globalReducer, { GlobalState }                                    from "./infrastructure/redux/global/GlobalReducer";
import mailGroupReducer
                                                                         from "./infrastructure/redux/mail/group/MailGroupReducer";
import mailGroupsReducer
                                                                         from "./infrastructure/redux/mail/group/MailGroupsReducer";
import mailSendReducer
                                                                         from "./infrastructure/redux/mail/send/MailSendReducer";
import mailSettingReducer
                                                                         from "./infrastructure/redux/mail/setting/MailSettingReducer";
import mailTemplateReducer
                                                                         from "./infrastructure/redux/mail/template/MailTemplateReducer";
import mailTemplatesReducer
                                                                         from "./infrastructure/redux/mail/template/MailTemplatesReducer";
import noticeReducer
                                                                         from "./infrastructure/redux/notice/NoticeReducer";
import notifyReducer
                                                                         from "./infrastructure/redux/notify/NotifyReducer";
import officeReducer
                                                                         from "./infrastructure/redux/office/OfficeReducer";
import { planPaginationReducer }                                         from "./infrastructure/redux/plan/pagination";
import { planReducer }                                                   from "./infrastructure/redux/plan/plan";
import { selectedPlanReducer }                                           from "./infrastructure/redux/plan/selected";
import customerRecordReducer
                                                                         from "./infrastructure/redux/record/customer/CustomerRecordReducer";
import customerRecordsReducer
                                                                         from "./infrastructure/redux/record/customer/CustomerRecordsReducer";
import recordTemplateReducer
                                                                         from "./infrastructure/redux/record/template/RecordTemplateReducer";
import recordTemplatesReducer
                                                                         from "./infrastructure/redux/record/template/RecordTemplatesReducer";
import { reservationCancelRequestCountReducer }                          from "./infrastructure/redux/reservation/cancel";
import { reservationHistoriesReducer }                                   from "./infrastructure/redux/reservation/history";
import reservationReducer
                                                                         from "./infrastructure/redux/reservation/ReservationReducer";
import reservationSettingReducer
                                                                         from "./infrastructure/redux/reservation/ReservationSettingReducer";
import reservationsReducer
                                                                         from "./infrastructure/redux/reservation/ReservationsReducer";
import staffReducer
                                                                         from "./infrastructure/redux/staff/StaffReducer";
import staffsReducer
                                                                         from "./infrastructure/redux/staff/StaffsReducer";
import { Routes }                                                        from "./routes/Routes";
import * as serviceWorker                                                from './serviceWorker';

if (process.env.NODE_ENV !== undefined && process.env.NODE_ENV !== "development") {
  LogRocket.init("hxxjtm/reska");
}
const history = createBrowserHistory();

export interface ResKaState {
  fetchStatus: FetchStatus;
  globalState: GlobalState;
  account: Account;
  notices: Notices;
  facilities: Facilities;
  reservationSetting: ReservationSetting;
  office: Office,
  corporation: Corporation,
  staffs: Staffs;
  staff: Staff;
  templates: RecordTemplates;
  template: RecordTemplate;
  customers: Customers;
  customer: Customer;
  customerRecords: CustomerRecords;
  customerRecord: CustomerRecord;
  mailSetting: MailSetting;
  mailTemplates: MailTemplates;
  mailTemplate: MailTemplate;
  mailGroups: MailGroups;
  mailGroup: MailGroup;
  mailSend: MailSend;
  reservation: Reservation;
  reservations: Reservations;
  plan: Plan;
  planPagination: Pagination;
  selectedPlan: Plan;
  reservationHistories: ReservationHistories;
  reservationCancelRequestCount: Count;
  notify: Notify;
  errors: Errors;
  router: RouterState;
}

const store = createStore(
  combineReducers<ResKaState>({
    fetchStatus: fetchStatusReducer,
    globalState: globalReducer,
    account: accountReducer,
    notices: noticeReducer,
    facilities: facilityReducer,
    reservationSetting: reservationSettingReducer,
    office: officeReducer,
    corporation: corporationReducer,
    staffs: staffsReducer,
    staff: staffReducer,
    templates: recordTemplatesReducer,
    template: recordTemplateReducer,
    customers: customersReducer,
    customer: customerReducer,
    customerRecords: customerRecordsReducer,
    customerRecord: customerRecordReducer,
    mailSetting: mailSettingReducer,
    mailTemplates: mailTemplatesReducer,
    mailTemplate: mailTemplateReducer,
    mailGroups: mailGroupsReducer,
    mailGroup: mailGroupReducer,
    mailSend: mailSendReducer,
    reservation: reservationReducer,
    reservations: reservationsReducer,
    plan: planReducer,
    planPagination: planPaginationReducer,
    selectedPlan: selectedPlanReducer,
    reservationHistories: reservationHistoriesReducer,
    reservationCancelRequestCount: reservationCancelRequestCountReducer,
    notify: notifyReducer,
    errors: errorReducer,
    router: connectRouter(history)
  }),
  applyMiddleware(routerMiddleware(history), LogRocket.reduxMiddleware()),
);

ReactDOM.render(
  <Provider store={ store }>
    <ConnectedRouter history={ history }>
      <Routes/>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root') as HTMLElement
);
serviceWorker.unregister();
